import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, CheckCircle2, Package, Star } from 'lucide-react';

const ProductsPage = () => {
  const navigate = useNavigate();

  const products = [
    {
      id: 'onyx-lighting',
      name: 'ONYX LED Potlight',
      tagline: '5-CCT Adjustable Technology',
      price: 12.99,
      image: 'https://customer-assets.emergentagent.com/job_elite-lighting/artifacts/g91hwz72_WhatsApp%20Image%202025-10-20%20at%2017.13.48.jpeg',
      available: true,
      badge: 'Best Seller',
      features: [
        '5 Color Temperature Settings (2700K-5000K)',
        'ETL, UL, CSA Certified',
        'IC-Rated & Wet Location Approved',
        'Dimmable (10-100%)',
        'Only 10W Power Consumption',
        '700 Lumens Output',
        '5-Year Warranty'
      ],
      description: 'Professional-grade 4" ONYX Potlight with adjustable color temperatures. Perfect for residential and commercial applications.'
    },
    {
      id: 'onyx-hvac',
      name: 'ONYX HVAC Clips',
      tagline: 'Professional Mounting Solution',
      price: null,
      image: null,
      available: false,
      badge: 'Coming Q2 2026',
      features: [
        'Heavy-Duty Construction',
        'Easy Installation',
        'Universal Compatibility',
        'Corrosion Resistant',
        'Professional Grade',
        'Bulk Pricing Available'
      ],
      description: 'Professional-grade HVAC mounting clips designed for secure potlight installation. Trusted by contractors nationwide.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            <button onClick={() => { window.scrollTo(0, 0); navigate('/'); }} className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_elite-lighting/artifacts/27f7yllt_WhatsApp%20Image%202025-10-18%20at%2008.58.35.jpeg" 
                alt="ONYX Home Solutions" 
                className="h-12 lg:h-16 w-auto object-contain"
                style={{ background: 'transparent' }}
              />
            </button>
            <div className="hidden md:flex items-center gap-8">
              <button onClick={() => { window.scrollTo(0, 0); navigate('/'); }} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">
                Home
              </button>
              <button onClick={() => { window.scrollTo(0, 0); navigate('/products'); }} className="text-sm font-medium transition-colors" style={{ color: '#8B6F47' }}>
                Products
              </button>
              <button onClick={() => { window.scrollTo(0, 0); navigate('/bulk-pricing'); }} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">
                Bulk
              </button>
              <button onClick={() => { window.scrollTo(0, 0); navigate('/guide'); }} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">
                Guides
              </button>
              <button onClick={() => { window.scrollTo(0, 0); navigate('/become-partner'); }} className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors">
                Become a Partner
              </button>
              <button onClick={() => { window.scrollTo(0, 0); navigate('/admin/login'); }} className="text-sm font-medium transition-colors" style={{ color: '#8B6F47' }}>
                Login
              </button>
              <button onClick={() => { window.scrollTo(0, 0); navigate('/cart'); }} className="relative p-2 rounded-full hover:bg-gray-100 transition-colors" style={{ color: '#8B6F47' }}>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </button>
            </div>
            <button 
              className="md:hidden p-2"
              onClick={() => {
                const menu = document.getElementById('mobile-menu');
                menu.classList.toggle('hidden');
              }}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
        <div id="mobile-menu" className="hidden md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-3 space-y-1">
            <button onClick={() => { window.scrollTo(0, 0); navigate('/'); }} className="block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg">
              Home
            </button>
            <button onClick={() => { window.scrollTo(0, 0); navigate('/products'); }} className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded-lg" style={{ color: '#8B6F47' }}>
              Products
            </button>
            <button onClick={() => { window.scrollTo(0, 0); navigate('/bulk-pricing'); }} className="block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg">
              Bulk
            </button>
            <button onClick={() => { window.scrollTo(0, 0); navigate('/guide'); }} className="block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg">
              Guides
            </button>
            <button onClick={() => { window.scrollTo(0, 0); navigate('/become-partner'); }} className="block w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg">
              Become a Partner
            </button>
            <button onClick={() => { window.scrollTo(0, 0); navigate('/admin/login'); }} className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-50 rounded-lg" style={{ color: '#8B6F47' }}>
              Login
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden" style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)' }}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, #D4A574 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 lg:px-8 text-center text-white">
          <div className="inline-block mb-6 px-6 py-2 rounded-full" style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}>
            <span className="text-sm font-bold">PREMIUM QUALITY</span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-bold mb-6">
            Our Product Line
          </h1>
          <p className="text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Engineered for excellence. Designed for professionals. Built to last.
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
            {products.map((product) => (
              <div key={product.id} className={`rounded-3xl overflow-hidden shadow-xl ${
                product.available ? 'bg-white' : 'bg-gray-50 border-2 border-dashed border-gray-300'
              }`}>
                {/* Product Images Grid or Placeholder */}
                {product.available && product.id === 'onyx-lighting' ? (
                  <div className="relative">
                    <div className="grid grid-cols-2 gap-2 p-2">
                      <img 
                        src="https://customer-assets.emergentagent.com/job_711851d8-a783-4abf-8185-8548b17cf2e3/artifacts/r1t3kgm3_image.png"
                        alt="ONYX Potlights Installation 1"
                        className="w-full h-48 object-cover rounded-xl"
                      />
                      <img 
                        src="https://customer-assets.emergentagent.com/job_711851d8-a783-4abf-8185-8548b17cf2e3/artifacts/l3g8ky26_image.png"
                        alt="ONYX Potlights Installation 2"
                        className="w-full h-48 object-cover rounded-xl"
                      />
                      <img 
                        src="https://customer-assets.emergentagent.com/job_711851d8-a783-4abf-8185-8548b17cf2e3/artifacts/bo43ocf5_image.png"
                        alt="ONYX Potlights Installation 3"
                        className="w-full h-48 object-cover rounded-xl"
                      />
                      <img 
                        src="https://customer-assets.emergentagent.com/job_711851d8-a783-4abf-8185-8548b17cf2e3/artifacts/c1bnl5ex_image.png"
                        alt="ONYX Potlights Installation 4"
                        className="w-full h-48 object-cover rounded-xl"
                      />
                    </div>
                    <div className="absolute top-6 right-6 px-4 py-2 rounded-full shadow-lg" style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}>
                      <span className="text-white text-sm font-bold">{product.badge}</span>
                    </div>
                  </div>
                ) : product.available ? (
                  <div className="relative h-80 flex items-center justify-center" style={{ background: '#f8f9fa' }}>
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4 px-4 py-2 rounded-full shadow-lg" style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}>
                      <span className="text-white text-sm font-bold">{product.badge}</span>
                    </div>
                  </div>
                ) : (
                  <div className="relative h-80 flex items-center justify-center" style={{ background: '#e5e7eb' }}>
                    <Package className="w-24 h-24 text-gray-400" />
                    <div className="absolute top-4 right-4 px-4 py-2 rounded-full shadow-lg" style={{ background: '#9ca3af' }}>
                      <span className="text-white text-sm font-bold">{product.badge}</span>
                    </div>
                  </div>
                )}

                {/* Product Info */}
                <div className="p-8 lg:p-10">
                  <h2 className="text-3xl font-bold mb-2" style={{ color: '#1d1d1f' }}>
                    {product.name}
                  </h2>
                  <p className="text-lg mb-4" style={{ color: '#8B6F47' }}>
                    {product.tagline}
                  </p>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {product.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 mb-8">
                    {product.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: product.available ? '#D4A574' : '#9ca3af' }} />
                        <span className={`text-sm ${product.available ? 'text-gray-700' : 'text-gray-500'}`}>{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* Price & CTA */}
                  {product.available ? (
                    <div>
                      <div className="flex items-baseline gap-2 mb-6">
                        <span className="text-4xl font-bold" style={{ color: '#8B6F47' }}>${product.price}</span>
                        <span className="text-gray-500">per unit</span>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <Button 
                          onClick={() => { window.scrollTo(0, 0); navigate('/product'); }}
                          className="flex-1 text-white py-6 rounded-full text-base font-medium"
                          style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}
                        >
                          View Details
                        </Button>
                        <Button 
                          onClick={() => { window.scrollTo(0, 0); navigate('/bulk-pricing'); }}
                          variant="outline"
                          className="flex-1 py-6 rounded-full text-base font-medium"
                          style={{ borderColor: '#8B6F47', color: '#8B6F47' }}
                        >
                          Bulk Pricing
                        </Button>
                      </div>
                      <div className="mt-4 flex items-center justify-center gap-1">
                        {[...Array(5)].map((_, i) => (
                          <Star key={i} className="w-4 h-4 fill-current text-yellow-400" />
                        ))}
                        <span className="text-sm text-gray-600 ml-2">5.0 (200+ reviews)</span>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center">
                      <p className="text-xl font-semibold text-gray-700 mb-4">Coming Q2 2026</p>
                      <Button 
                        onClick={() => { window.scrollTo(0, 0); navigate('/become-partner'); }}
                        variant="outline"
                        className="py-4 px-8 rounded-full border-2"
                        style={{ borderColor: '#8B6F47', color: '#8B6F47' }}
                      >
                        Get Notified
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4" style={{ color: '#1d1d1f' }}>
            Ready to Upgrade Your Space?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Get volume discounts on bulk orders or request a custom quote
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => { window.scrollTo(0, 0); navigate('/bulk-pricing'); }}
              className="text-white px-8 py-4 rounded-full text-lg font-medium"
              style={{ background: 'linear-gradient(135deg, #D4A574 0%, #8B6F47 100%)' }}
            >
              View Bulk Pricing
            </Button>
            <Button 
              onClick={() => { window.scrollTo(0, 0); navigate('/become-partner'); }}
              variant="outline"
              className="px-8 py-4 rounded-full text-lg font-medium border-2"
              style={{ borderColor: '#8B6F47', color: '#8B6F47' }}
            >
              Become a Partner
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-4 lg:px-8 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <p className="text-gray-400 text-sm">Premium LED lighting and HVAC solutions for modern homes.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Products</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => { window.scrollTo(0, 0); navigate('/products'); }} className="text-gray-400 hover:text-white">ONYX Lighting</button></li>
                <li><button onClick={() => { window.scrollTo(0, 0); navigate('/products'); }} className="text-gray-400 hover:text-white">ONYX HVAC</button></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => { window.scrollTo(0, 0); navigate('/'); }} className="text-gray-400 hover:text-white">About Us</button></li>
                <li><button onClick={() => { window.scrollTo(0, 0); navigate('/become-partner'); }} className="text-gray-400 hover:text-white">Become a Partner</button></li>
                <li><button onClick={() => { window.scrollTo(0, 0); navigate('/guide'); }} className="text-gray-400 hover:text-white">Guides</button></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="mailto:info@onyx-homesolutions.com" className="text-gray-400 hover:text-white">info@onyx-homesolutions.com</a></li>
                <li><a href="tel:519-996-2866" className="text-gray-400 hover:text-white">519-996-2866</a></li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
            <p>© 2025 ONYX Home Solutions. All rights reserved. | Powered by Syntrexe</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProductsPage;
